import React, {useEffect, useState} from 'react';
import {QuantityPicker} from 'react-qty-picker';
import OrderService from "@/modules/front/services/OrderService";


const AddToCartWithQuantityButton = (props) => {

    const [value, setValue] = useState(1);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState(true);

    const [isSuccess, setIsSuccess] = useState(false);

    if (!props.productId) {
        return 'Tento produkt nelze rezervovat.';
    }

    useEffect(() => {
        if (value <= 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [value]);

    // Set isSucess to false after1 second
    useEffect(() => {
        if (isSuccess) {
            const timer = setTimeout(() => {
                setIsSuccess(false);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [isSuccess]);


    const handleClick = () => {

        setLoading(true);

        OrderService.addToCart(props.productId, value, props.dateFrom, props.dateTo)
            .then((response) => {
                setLoading(false);

                if (response.success) {
                    setIsSuccess(true);
                } else {
                    alert('Produkt se nepodařilo přidat do rezervace.');
                }


            })
            .catch((error) => {
                setLoading(false);
                alert('Produkt se nepodařilo přidat do rezervace.');
            });


    };


    let button;
    const buttonClass = "btn btn-primary ms-2 d-flex align-items-center ";
    if (loading || disabled) {
        button = <div className={buttonClass + "disabled btn-disabled"} disabled>Přidat <i
            className='fas fa-spin fa-spinner ps-3'></i></div>;
    } else {
        button = <div className={buttonClass} onClick={handleClick}>Přidat <i className='fas fa-plus ps-3'></i></div>;
    }
    if (isSuccess) {
        button = <div className={buttonClass + "disabled btn-disabled"} disabled>Přidáno <i
            className='fas fa-check ps-3'></i></div>;
    }

    return (
        <>
            <div className="d-flex align-items-stretch">
                <QuantityPicker
                    max={props.availableQuantity ? props.availableQuantity : 100}
                    value={value}
                    onChange={(quantity) => setValue(quantity)}
                    allowTextInput={true}
                />
                <span className="ps-2">
                    {props.unit}
                </span>
                {button}
            </div>
        </>
    );
};

export default AddToCartWithQuantityButton;